import { useEffect } from "react";
import { lang } from "../../i18nLang";
import {
  DiscountLinkStore,
  DiscountStore,
  MeasurementStore,
} from "../../store/index";
import DialogModal from "../UI/DialogModals";
import InstallmentsTableLink from "../shared/Installments/TableLink/TableLink";

const label = "discounts.linkModal";

interface IProps {
  /** Propriedade que indica se o modal está aberto ou fechado. */
  open: boolean;
  /** Função que será chamada ao fechar o modal */
  onClose: () => void;
}

/** Formulário para vincular parcelas de descontos a medição atual.
 * @category Components
 */
const DiscountLink = (props: IProps) => {
  const measurement = MeasurementStore.currentMeasurement;

  useEffect(() => {
    DiscountStore.addDiscountsObserver();

    return () => {
      DiscountStore.removeObserver();
    };
  }, []);

  useEffect(() => {
    if (props.open) {
      DiscountLinkStore.reset();
      DiscountLinkStore.getCurrentLinks();
    }
  }, [props.open]);

  const handleConfirm = async () => {
    return await DiscountLinkStore.updateDiscountsLinkWithMeasurement();
  };

  const handleSelectInstallment = (discountId, installmentId, checked) => {
    if (checked) {
      DiscountLinkStore.addItemToDiscountLink(discountId, installmentId);
    } else {
      DiscountLinkStore.removeItemFromDiscountLink(discountId, installmentId);
    }
  };

  return (
    <DialogModal
      title={lang(`${label}.title`)}
      open={props.open}
      onClose={props.onClose}
      confirmLabel={lang("link")}
      onConfirm={handleConfirm}
      disabledConfirm={!measurement?.canEdit()}
      maxWidth="md"
    >
      <InstallmentsTableLink
        store={DiscountLinkStore}
        onSelectInstallment={handleSelectInstallment}
        notFoundMessage={{
          title: lang(`${label}.notFound.title`),
          subtitle: lang(`${label}.notFound.subtitle`),
          trail: lang(`${label}.notFound.trail`),
        }}
      />
    </DialogModal>
  );
};

export default DiscountLink;
